import SectionTitle from "../components/SectionTitle";
import PageSeo from "../components/PageSeo";
import Reveal from "../components/Reveal";

export default function AvisoLegal() {
  return (
    <div>
      <PageSeo
        title="Aviso Legal"
        description="Aviso legal de la Asociación Pequeño Fresno: identificación del titular, condiciones de uso y legislación aplicable."
        path="/aviso-legal"
      />
      <section className="max-w-3xl mx-auto px-6">
        <SectionTitle>~ aviso legal ~</SectionTitle>

        <Reveal>
          <div className="prose-body text-[color:var(--text)] space-y-8">
            <div>
              <h2 className="h-serif text-2xl font-semibold text-[color:var(--brand-strong)] mb-3">1. Identificación del titular</h2>
              <p>En cumplimiento de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa que el presente sitio web es titularidad de:</p>
              <ul className="mt-2">
                <li><strong>Denominación:</strong> Asociación Pequeño Fresno Esclerosis Tuberosa</li>
                <li><strong>Número de inscripción:</strong> CV-01-066518-A (Registro Autonómico, Sección Primera)</li>
                <li><strong>NIF:</strong> G75532028</li>
                <li><strong>Domicilio social:</strong> Calle Palangre número 13, bungalow 35, 03540 Alicante, España</li>
                <li><strong>Correo electrónico:</strong> info@pequenofresno.net</li>
              </ul>
            </div>

            <div>
              <h2 className="h-serif text-2xl font-semibold text-[color:var(--brand-strong)] mb-3">2. Objeto</h2>
              <p>La Asociación Pequeño Fresno pone a disposición de los usuarios este sitio web con fines informativos y solidarios, orientados a difundir el Complejo de Esclerosis Tuberosa (CET), apoyar a familias afectadas y facilitar la colaboración a través de donaciones y voluntariado.</p>
            </div>

            <div>
              <h2 className="h-serif text-2xl font-semibold text-[color:var(--brand-strong)] mb-3">3. Condiciones de uso</h2>
              <p>El acceso y navegación por este sitio implica la aceptación de las presentes condiciones. El usuario se compromete a hacer un uso lícito, adecuado y respetuoso de los contenidos, sin utilizarlos para fines contrarios a la ley, la moral o el orden público.</p>
              <p>Queda prohibida cualquier reproducción, transformación, distribución o comunicación pública no autorizada de los contenidos del sitio.</p>
            </div>

            <div>
              <h2 className="h-serif text-2xl font-semibold text-[color:var(--brand-strong)] mb-3">4. Propiedad intelectual e industrial</h2>
              <p>Todos los contenidos del sitio (textos, imágenes, logotipos, diseño, código fuente) son propiedad de la Asociación Pequeño Fresno o de terceros que han autorizado su uso, y están protegidos por la normativa de propiedad intelectual e industrial.</p>
              <p>El logotipo, la marca “Pequeño Fresno” y los signos distintivos de la asociación no podrán utilizarse sin autorización expresa por escrito.</p>
            </div>

            <div>
              <h2 className="h-serif text-2xl font-semibold text-[color:var(--brand-strong)] mb-3">5. Enlaces a terceros</h2>
              <p>Este sitio puede contener enlaces a páginas externas (p. ej. DonorBox para donaciones, Google Drive para vídeos informativos, redes sociales, sitios web de organizaciones colaboradoras como FEDER, ALCE o el Consorcio TAND). La Asociación Pequeño Fresno no se hace responsable del contenido, disponibilidad ni políticas de dichos sitios de terceros.</p>
            </div>

            <div>
              <h2 className="h-serif text-2xl font-semibold text-[color:var(--brand-strong)] mb-3">6. Exclusión de responsabilidad</h2>
              <p>La información publicada sobre el Complejo de Esclerosis Tuberosa (CET) tiene carácter divulgativo y en ningún caso sustituye el consejo médico profesional. Para cualquier decisión clínica se recomienda consultar con un profesional sanitario cualificado.</p>
              <p>La asociación hace sus mejores esfuerzos por mantener actualizado y correcto el contenido, pero no garantiza la ausencia de errores ni la disponibilidad ininterrumpida del sitio.</p>
            </div>

            <div>
              <h2 className="h-serif text-2xl font-semibold text-[color:var(--brand-strong)] mb-3">7. Modificaciones</h2>
              <p>La asociación se reserva el derecho a modificar en cualquier momento el presente aviso legal, así como los contenidos y servicios ofrecidos en el sitio web, sin previo aviso.</p>
            </div>

            <div>
              <h2 className="h-serif text-2xl font-semibold text-[color:var(--brand-strong)] mb-3">8. Legislación aplicable y jurisdicción</h2>
              <p>Las presentes condiciones se rigen por la legislación española. Para la resolución de cualquier controversia derivada del uso de este sitio, las partes se someten a los Juzgados y Tribunales de Alicante, con renuncia expresa a cualquier otro fuero que pudiera corresponderles.</p>
            </div>

            <p className="text-sm italic text-[color:var(--text-soft)]">Última actualización: 19 de agosto de 2026</p>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
